import { HttpResponse } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {RequestParamModel, ResponseModel} from '../models';
import {PaginationModel} from '../models';
import {BaseService} from '../services';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {CarrierModel} from '../models/carrier.model';

@Injectable({
    providedIn: 'root'
})
export class CarrierService {

    constructor(private baseService: BaseService) {
    }

    // get all carrier list
    getCarriers(requestParamModel: RequestParamModel): any {
        return this.baseService.get('carrier', requestParamModel)
            .pipe(map<any, any>(response => {
                const carrierList = new PaginationModel<CarrierModel>();
                const headers = response.headers;
                carrierList.setHeaders(headers);
                carrierList.data = response.body.data as CarrierModel[];
                return carrierList;
          }),
        catchError(err => throwError(() => err))
    );
    }

    getRegions(requestParamModel: RequestParamModel): any {
        // return this.baseService.get('shipping-region')
        //     .pipe(map<any, any>(response => {
        //         return response.body.data as any;
        //     }, (err: any) => {
        //         return err;
        //     }));
        return this.baseService.get('shipping-region', requestParamModel)
            .pipe(map<any, any>(response => {
                const regionList = new PaginationModel<CarrierModel>();
                const headers = response.headers;
                regionList.setHeaders(headers);
                return response.body.data;
        }),
        catchError(err => throwError(() => err))
    );
    }

    createCarrier(carrierModel: any): any {
        if (carrierModel.id !== undefined) {
            return this.baseService.patch('carrier/' + carrierModel.id, carrierModel)
                .pipe(map<any, number>(response => {
                        carrierModel = response.data as any;
                        return carrierModel;
                    }),
                      catchError(err => throwError(() => err))
                  );
        } else {
            return this.baseService.post('carrier', carrierModel)
                .pipe(map<any, number>(response => {
                        carrierModel = response.data as any;
                        return carrierModel;
                    }),
                      catchError(err => throwError(() => err))
                  );

        }
    }

    delete(_id: any) {
        return this.baseService.delete('carrier/' + _id)
            .pipe(map<any, number>(response => {
                    return response;
           }),
                  catchError(err => throwError(() => err))
              );
    }
}
